/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureUserBlackListModel } from './restructuring';
import { restructureUserModel } from '../../../users/services/UserService/restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

const getUserBlackListByAuthUser = async (state, queryParams) => {
  const response = await api.get('/user-black-list/me', {
    expand: 'blockedUser',
    ...queryParams
  });
  const responseJson = await response.json();
  if (!responseJson.success) {
    return {
      response: responseJson,
      destructData: null
    };
  }
  return {
    response: responseJson,
    destructData: {
      itemsById: _.keyBy(
        _.map(responseJson.data.items, item =>
          restructureUserBlackListModel(state, item)
        ),
        'id'
      ),
      usersById: _.keyBy(
        _.map(responseJson.data.items, item =>
          restructureUserModel(state, item.blockedUser)
        ),
        'id'
      ),
      itemsIds: _.map(responseJson.data.items, item => item.id),
      pagination: restructurePaginationModel(_.get(responseJson, 'data._meta'))
    }
  };
};

class UserBlackListService {
  async addUserBlackListToExecutorList(state, data) {
    const response = await api.post('/user-black-list/executor-list', {}, data);
    const responseJson = await response.json();
    return responseJson;
  }

  async addUserBlackListToCustomerList(state, data) {
    const response = await api.post('/user-black-list/customer-list', {}, data);
    const responseJson = await response.json();
    return responseJson;
  }

  async deleteBlockedUserInExecutorList(state, blockedUserId) {
    const response = await api.del(
      `/user-black-list/executor-list/remove-by-blocked-user/${blockedUserId}`,
      {}
    );
    if (response.status === 204) {
      return response;
    }
    const responseJson = await response.json();
    return responseJson;
  }

  async deleteBlockedUserInCustomerList(state, blockedUserId) {
    const response = await api.del(
      `/user-black-list/customer-list/remove-by-blocked-user/${blockedUserId}`,
      {}
    );
    if (response.status === 204) {
      return response;
    }
    const responseJson = await response.json();
    return responseJson;
  }

  async getUserBlackListByCustomers(state, queryParams) {
    const result = await getUserBlackListByAuthUser(state, {
      ...queryParams,
      ...{ category: 1 }
    });
    return result;
  }

  async getUserBlackListByExecutors(state, queryParams) {
    const result = await getUserBlackListByAuthUser(state, {
      ...queryParams,
      ...{ category: 2 }
    });
    return result;
  }
}

export default new UserBlackListService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userBlackList/services/UserBlackListService/UserBlackListService.js